import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { formatDate } from '@angular/common';

@Component({
    selector: 'app-avenant',
    templateUrl: './avenant.component.html',
    styleUrls: ['./avenant.component.scss']
})
export class AvenantComponent implements OnInit {

    @Input() libelleQualification : string;
    @Input() avenant : any;
    @Input() index : any;
    @Input() qualificationCTList : any;
    // @Input() qualificationDefault : any;
    @Input() qualifSal : any;
    @Input() dureeConst : any;

    @Output() removeAvenantEvent = new EventEmitter<any>();
    @Output() updateAvenantEvent = new EventEmitter<any>();

    listUniteTravail = [
        {
            "value" : "HS",
            "nom" : "Heures / Semaine",
            "selected" : false,
        },
        {
            "value" : "HA",
            "nom" : "Forfait Heures Annuel",
            "selected" : false,
        },
        {
            "value" : "JA",
            "nom" : "Forfait Jours Annuel",
            "selected" : false,
        },
    ];

    constructor(
        private cdf: ChangeDetectorRef,
    ) { 
    }

    ngOnInit() {
        this.setComponent();
    }

    ngOnChanges() {
        this.setComponent();
    }

    setComponent() {
        this.listUniteTravail.forEach((unite) => {
            if (this.avenant.tempsTravailUnite == unite.value) {
                unite.selected = true;
            }
        })

        this.updateAvenant();
    }

    removeAvenant(avenant : any) {
        this.removeAvenantEvent.emit(avenant);
    }

    updateAvenant() {
        this.updateAvenantEvent.emit(this.avenant);
        this.cdf.detectChanges();
    }

    toggleChipQualification(chip : any) {
        this.avenant.qualification = null;
        this.qualificationCTList.forEach(c => {
            if (chip.id == c.id) {
                this.avenant.qualification = chip.id;
            } else {
            }
        });
    }

    toggleChipUniteTravail(chip, list) {
        this.avenant.tempsTravailUnite = null;
        list.forEach(c => {
            if (chip.nom == c.nom) {
                c.selected = true;
                this.avenant.tempsTravailUnite = chip.value;
                this.updateAvenant();
            } else {
                c.selected = false;
            }
        });
    }
}
